import AppointmentContainer from "./TwoFAEnabled.container";

export default AppointmentContainer;
